import {CheckboxOptionType, Radio} from 'antd';
import "./ButtonGroup.css"
import React from "react";

type ButtonGroupProps = {
    options: CheckboxOptionType[];
    onChange: (value: any) => void;
    value: any;
};

const ButtonGroup = ({options, onChange, value=null}:ButtonGroupProps) => {
    return (
        <Radio.Group
            options={options}
            onChange={(e) => {onChange(e.target.value);}}
            value={value}
            className="button-group"
            optionType="button"
            buttonStyle="solid"
        />
    )
};

export default ButtonGroup
